import {
  selectChattelDetailsPendingChanges,
  selectLoanAndLockPendingChanges,
  selectLoanContactsPendingChanges,
  selectPropertyPendingChanges,
} from 'store/loanApplications/selectors';

import { ENTITY_TYPE_HREF_MAP } from '../EditModal.constants';

import {
  getChattelDetailsRequestBody,
  getContactsBodyRequestAction,
  getLoanAndLockRequestBody,
  getPropertyAndLoanRequestBody,
  normalizeChattelApplicationData,
  normalizeChattelPendingChangesAction,
  normalizeContactsApplicationData,
  normalizeContactsPendingChanges,
  normalizeLoanAndLockApplicationData,
  normalizeLoanAndLockPendingChangesAction,
  normalizePropertyAndLoanApplicationData,
  normalizePropertyAndLoanPendingChangesAction,
} from './Content.utils';

export const ENTITY_SECTION_NORMALIZE_DATA_FUNCTION_MAP = {
  [ENTITY_TYPE_HREF_MAP.PROPERTY_INFO]: normalizePropertyAndLoanApplicationData,
  [ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK]: normalizeLoanAndLockApplicationData,
  [ENTITY_TYPE_HREF_MAP.CONTACTS]: normalizeContactsApplicationData,
  [ENTITY_TYPE_HREF_MAP.CHATTEL]: normalizeChattelApplicationData,
};

export const ENTITY_SECTION_GET_REQUEST_BODY_FUNCTION_MAP = {
  [ENTITY_TYPE_HREF_MAP.PROPERTY_INFO]: getPropertyAndLoanRequestBody,
  [ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK]: getLoanAndLockRequestBody,
  [ENTITY_TYPE_HREF_MAP.CONTACTS]: getContactsBodyRequestAction,
  [ENTITY_TYPE_HREF_MAP.CHATTEL]: getChattelDetailsRequestBody,
};

export const ENTITY_SECTION_PENDING_CHANGES_SELECTOR_MAP = {
  [ENTITY_TYPE_HREF_MAP.PROPERTY_INFO]: selectPropertyPendingChanges,
  [ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK]: selectLoanAndLockPendingChanges,
  [ENTITY_TYPE_HREF_MAP.CONTACTS]: selectLoanContactsPendingChanges,
  [ENTITY_TYPE_HREF_MAP.CHATTEL]: selectChattelDetailsPendingChanges,
};

export const ENTITY_SECTION_NORMALIZE_PENDING_CHANGES_FUNCTION_MAP = {
  [ENTITY_TYPE_HREF_MAP.PROPERTY_INFO]: normalizePropertyAndLoanPendingChangesAction,
  [ENTITY_TYPE_HREF_MAP.LOAN_AND_LOCK]: normalizeLoanAndLockPendingChangesAction,
  [ENTITY_TYPE_HREF_MAP.CONTACTS]: normalizeContactsPendingChanges,
  [ENTITY_TYPE_HREF_MAP.CHATTEL]: normalizeChattelPendingChangesAction,
};

export const DELETED_ENTITY_SECTION_MESSAGE_MAP = {
  [ENTITY_TYPE_HREF_MAP.CONTACTS]: 'contact',
};
